import { useDriversState } from '../../../../../hooks/useDriversState';

/**
 * This hook is used for pages with specific content height that is under a map small container.
 */
export const useRetrieveStaticHeight = () => {
  const { driversState } = useDriversState();
  const innerHeight = driversState.height;

  return {
    mapHeight: innerHeight / 3,
    contentHeight: innerHeight - innerHeight / 3,
  };
};
